import React, { useEffect, useState } from "react";
import { Download, X } from "lucide-react";

// Add-to-home-screen prompt (Android/desktop via beforeinstallprompt; iOS shows manual hint)
export default function InstallPrompt() {
  const [evt, setEvt] = useState(null);
  const [show, setShow] = useState(false);
  const [ios, setIos] = useState(false);

  useEffect(() => {
    if (window.matchMedia("(display-mode: standalone)").matches || localStorage.getItem("apmercl_install_dismissed")) return;
    const onPrompt = (e) => { e.preventDefault(); setEvt(e); setShow(true); };
    window.addEventListener("beforeinstallprompt", onPrompt);
    const isIos = /iphone|ipad|ipod/i.test(navigator.userAgent) && !window.navigator.standalone;
    if (isIos) { setIos(true); setShow(true); }
    return () => window.removeEventListener("beforeinstallprompt", onPrompt);
  }, []);

  const dismiss = () => { setShow(false); localStorage.setItem("apmercl_install_dismissed", "1"); };
  const install = async () => {
    if (!evt) return;
    evt.prompt();
    await evt.userChoice;
    setShow(false);
  };

  useEffect(() => {
    document.body.classList.toggle("has-install-prompt", show);
    return () => document.body.classList.remove("has-install-prompt");
  }, [show]);

  if (!show) return null;
  return (
    <div data-testid="install-prompt" className="install-prompt">
      <img src="/img/icon-192.png" alt="APMERCL" style={{ width: 40, height: 40, borderRadius: 12, flexShrink: 0 }} />
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontWeight: 800, color: "#1C1917", fontSize: 13.5 }}>Install APMERCL App</div>
        <div style={{ fontSize: 12, color: "#57534E", lineHeight: 1.35 }} className="install-prompt-sub">
          {ios ? "Tap Share → “Add to Home Screen” for quick access." : "Add to the home screen for one-tap access."}
        </div>
      </div>
      {!ios && <button data-testid="install-app-btn" onClick={install} className="btn-primary-3d" style={{ padding: "8px 12px", fontSize: 12 }}><Download size={13} /> Install</button>}
      <button data-testid="install-dismiss-btn" onClick={dismiss} aria-label="Dismiss" style={{ background: "transparent", border: "none", color: "#78716C", cursor: "pointer", padding: 4, flexShrink: 0 }}><X size={16} /></button>
    </div>
  );
}
